{
  "formatVersion": 1,
  "name": "blackline-harbour",
  "displayName": "Harbour",
  "description": "A container dock at dusk: a panel warehouse with two internal catwalks holds the centre, container walls split each team's yard from the middle with two crossings apiece, crane piers give the middle band its high ground, and the two quayside lanes run the full length of the map for the sniper.",
  "visual": null,
  "environment": "golden",
  "brushes": [
    {
      "kind": "box",
      "center": [
        0,
        -0.5,
        0
      ],
      "halfExtents": [
        40,
        0.5,
        28
      ],
      "material": "asphalt",
      "note": "harbour asphalt floor"
    },
    {
      "kind": "box",
      "center": [
        0,
        3,
        -27.75
      ],
      "halfExtents": [
        40,
        3,
        0.25
      ],
      "material": "concrete",
      "note": "perimeter north wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        3,
        27.75
      ],
      "halfExtents": [
        40,
        3,
        0.25
      ],
      "material": "concrete",
      "note": "perimeter south wall"
    },
    {
      "kind": "box",
      "center": [
        39.75,
        3,
        0
      ],
      "halfExtents": [
        0.25,
        3,
        27.5
      ],
      "material": "concrete",
      "note": "perimeter east wall"
    },
    {
      "kind": "box",
      "center": [
        -39.75,
        3,
        0
      ],
      "halfExtents": [
        0.25,
        3,
        27.5
      ],
      "material": "concrete",
      "note": "perimeter west wall"
    },
    {
      "kind": "box",
      "center": [
        -36,
        2.5,
        27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        -36,
        2.5,
        -27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        -28,
        2.5,
        27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        -28,
        2.5,
        -27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        -20,
        2.5,
        27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        -20,
        2.5,
        -27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        -12,
        2.5,
        27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        -12,
        2.5,
        -27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        -4,
        2.5,
        27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        -4,
        2.5,
        -27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        4,
        2.5,
        27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        4,
        2.5,
        -27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        12,
        2.5,
        27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        12,
        2.5,
        -27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        20,
        2.5,
        27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        20,
        2.5,
        -27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        28,
        2.5,
        27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        28,
        2.5,
        -27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        36,
        2.5,
        27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        36,
        2.5,
        -27.4
      ],
      "halfExtents": [
        3.4,
        2.5,
        0.1
      ],
      "material": "rust",
      "note": "quay wall panel"
    },
    {
      "kind": "box",
      "center": [
        -10,
        3.5,
        -9.8
      ],
      "halfExtents": [
        4,
        3.5,
        0.2
      ],
      "material": "panel",
      "note": "warehouse north wall"
    },
    {
      "kind": "box",
      "center": [
        -4,
        5,
        -9.8
      ],
      "halfExtents": [
        2,
        2,
        0.2
      ],
      "material": "panel",
      "note": "warehouse north lintel"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.5,
        -9.8
      ],
      "halfExtents": [
        2,
        3.5,
        0.2
      ],
      "material": "panel",
      "note": "warehouse north wall"
    },
    {
      "kind": "box",
      "center": [
        4,
        5,
        -9.8
      ],
      "halfExtents": [
        2,
        2,
        0.2
      ],
      "material": "panel",
      "note": "warehouse north lintel"
    },
    {
      "kind": "box",
      "center": [
        10,
        3.5,
        -9.8
      ],
      "halfExtents": [
        4,
        3.5,
        0.2
      ],
      "material": "panel",
      "note": "warehouse north wall"
    },
    {
      "kind": "box",
      "center": [
        -10,
        3.5,
        9.8
      ],
      "halfExtents": [
        4,
        3.5,
        0.2
      ],
      "material": "panel",
      "note": "warehouse south wall"
    },
    {
      "kind": "box",
      "center": [
        -4,
        5,
        9.8
      ],
      "halfExtents": [
        2,
        2,
        0.2
      ],
      "material": "panel",
      "note": "warehouse south lintel"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.5,
        9.8
      ],
      "halfExtents": [
        2,
        3.5,
        0.2
      ],
      "material": "panel",
      "note": "warehouse south wall"
    },
    {
      "kind": "box",
      "center": [
        4,
        5,
        9.8
      ],
      "halfExtents": [
        2,
        2,
        0.2
      ],
      "material": "panel",
      "note": "warehouse south lintel"
    },
    {
      "kind": "box",
      "center": [
        10,
        3.5,
        9.8
      ],
      "halfExtents": [
        4,
        3.5,
        0.2
      ],
      "material": "panel",
      "note": "warehouse south wall"
    },
    {
      "kind": "box",
      "center": [
        13.8,
        3.5,
        -7.8
      ],
      "halfExtents": [
        0.2,
        3.5,
        1.8
      ],
      "material": "panel",
      "note": "warehouse east wall"
    },
    {
      "kind": "box",
      "center": [
        13.8,
        2,
        -4
      ],
      "halfExtents": [
        0.2,
        2,
        2
      ],
      "material": "panel",
      "note": "warehouse east sill"
    },
    {
      "kind": "box",
      "center": [
        13.8,
        6.25,
        -4
      ],
      "halfExtents": [
        0.2,
        0.75,
        2
      ],
      "material": "panel",
      "note": "warehouse east lintel"
    },
    {
      "kind": "box",
      "center": [
        13.8,
        3.5,
        0
      ],
      "halfExtents": [
        0.2,
        3.5,
        2
      ],
      "material": "panel",
      "note": "warehouse east wall"
    },
    {
      "kind": "box",
      "center": [
        13.8,
        2,
        4
      ],
      "halfExtents": [
        0.2,
        2,
        2
      ],
      "material": "panel",
      "note": "warehouse east sill"
    },
    {
      "kind": "box",
      "center": [
        13.8,
        6.25,
        4
      ],
      "halfExtents": [
        0.2,
        0.75,
        2
      ],
      "material": "panel",
      "note": "warehouse east lintel"
    },
    {
      "kind": "box",
      "center": [
        13.8,
        3.5,
        7.8
      ],
      "halfExtents": [
        0.2,
        3.5,
        1.8
      ],
      "material": "panel",
      "note": "warehouse east wall"
    },
    {
      "kind": "box",
      "center": [
        -13.8,
        3.5,
        -7.8
      ],
      "halfExtents": [
        0.2,
        3.5,
        1.8
      ],
      "material": "panel",
      "note": "warehouse west wall"
    },
    {
      "kind": "box",
      "center": [
        -13.8,
        2,
        -4
      ],
      "halfExtents": [
        0.2,
        2,
        2
      ],
      "material": "panel",
      "note": "warehouse west sill"
    },
    {
      "kind": "box",
      "center": [
        -13.8,
        6.25,
        -4
      ],
      "halfExtents": [
        0.2,
        0.75,
        2
      ],
      "material": "panel",
      "note": "warehouse west lintel"
    },
    {
      "kind": "box",
      "center": [
        -13.8,
        3.5,
        0
      ],
      "halfExtents": [
        0.2,
        3.5,
        2
      ],
      "material": "panel",
      "note": "warehouse west wall"
    },
    {
      "kind": "box",
      "center": [
        -13.8,
        2,
        4
      ],
      "halfExtents": [
        0.2,
        2,
        2
      ],
      "material": "panel",
      "note": "warehouse west sill"
    },
    {
      "kind": "box",
      "center": [
        -13.8,
        6.25,
        4
      ],
      "halfExtents": [
        0.2,
        0.75,
        2
      ],
      "material": "panel",
      "note": "warehouse west lintel"
    },
    {
      "kind": "box",
      "center": [
        -13.8,
        3.5,
        7.8
      ],
      "halfExtents": [
        0.2,
        3.5,
        1.8
      ],
      "material": "panel",
      "note": "warehouse west wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        7.2,
        0
      ],
      "halfExtents": [
        14,
        0.2,
        10
      ],
      "material": "metal",
      "note": "warehouse roof"
    },
    {
      "kind": "box",
      "center": [
        0,
        -0.14,
        0
      ],
      "halfExtents": [
        13.6,
        0.15,
        9.6
      ],
      "material": "concrete",
      "note": "warehouse floor"
    },
    {
      "kind": "box",
      "center": [
        -9,
        1.3,
        6
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "rust",
      "note": "container x level 0"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.6,
        7.5
      ],
      "halfExtents": [
        1.2,
        0.6,
        1.2
      ],
      "material": "wood",
      "note": "crate block"
    },
    {
      "kind": "box",
      "center": [
        9,
        1.3,
        -6
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "rust",
      "note": "container x level 0"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.6,
        -7.5
      ],
      "halfExtents": [
        1.2,
        0.6,
        1.2
      ],
      "material": "wood",
      "note": "crate block"
    },
    {
      "kind": "box",
      "center": [
        0,
        6.4,
        0
      ],
      "halfExtents": [
        0.5,
        0.06,
        0.5
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "warehouse centre pendant fixture"
    },
    {
      "kind": "box",
      "center": [
        -7,
        6.2,
        -5
      ],
      "halfExtents": [
        0.4,
        0.06,
        0.4
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "warehouse bay pendant fixture"
    },
    {
      "kind": "box",
      "center": [
        -4,
        3.4,
        -10.8
      ],
      "halfExtents": [
        0.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "warehouse door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        4,
        3.4,
        -10.8
      ],
      "halfExtents": [
        0.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "warehouse door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -6.8,
        3.05,
        5.8
      ],
      "halfExtents": [
        6.8,
        0.15,
        3.8
      ],
      "material": "metal",
      "note": "catwalk deck"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.075,
        -2.843
      ],
      "halfExtents": [
        1,
        0.075,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 1"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.15,
        -2.617
      ],
      "halfExtents": [
        1,
        0.15,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 2"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.225,
        -2.392
      ],
      "halfExtents": [
        1,
        0.225,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 3"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.3,
        -2.167
      ],
      "halfExtents": [
        1,
        0.3,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 4"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.375,
        -1.943
      ],
      "halfExtents": [
        1,
        0.375,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 5"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.45,
        -1.717
      ],
      "halfExtents": [
        1,
        0.45,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 6"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.525,
        -1.492
      ],
      "halfExtents": [
        1,
        0.525,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 7"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.6,
        -1.267
      ],
      "halfExtents": [
        1,
        0.6,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 8"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.675,
        -1.042
      ],
      "halfExtents": [
        1,
        0.675,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 9"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.75,
        -0.817
      ],
      "halfExtents": [
        1,
        0.75,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 10"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.825,
        -0.592
      ],
      "halfExtents": [
        1,
        0.825,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 11"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.9,
        -0.368
      ],
      "halfExtents": [
        1,
        0.9,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 12"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.975,
        -0.143
      ],
      "halfExtents": [
        1,
        0.975,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 13"
    },
    {
      "kind": "box",
      "center": [
        -8,
        1.05,
        0.083
      ],
      "halfExtents": [
        1,
        1.05,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 14"
    },
    {
      "kind": "box",
      "center": [
        -8,
        1.125,
        0.308
      ],
      "halfExtents": [
        1,
        1.125,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 15"
    },
    {
      "kind": "box",
      "center": [
        -8,
        1.2,
        0.533
      ],
      "halfExtents": [
        1,
        1.2,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 16"
    },
    {
      "kind": "box",
      "center": [
        -8,
        1.275,
        0.757
      ],
      "halfExtents": [
        1,
        1.275,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 17"
    },
    {
      "kind": "box",
      "center": [
        -8,
        1.35,
        0.982
      ],
      "halfExtents": [
        1,
        1.35,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 18"
    },
    {
      "kind": "box",
      "center": [
        -8,
        1.425,
        1.208
      ],
      "halfExtents": [
        1,
        1.425,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 19"
    },
    {
      "kind": "box",
      "center": [
        -8,
        1.5,
        1.433
      ],
      "halfExtents": [
        1,
        1.5,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 20"
    },
    {
      "kind": "box",
      "center": [
        -8,
        1.575,
        1.657
      ],
      "halfExtents": [
        1,
        1.575,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 21"
    },
    {
      "kind": "box",
      "center": [
        -8,
        1.6,
        1.883
      ],
      "halfExtents": [
        1,
        1.6,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 22"
    },
    {
      "kind": "box",
      "center": [
        -11.3,
        3.75,
        2.15
      ],
      "halfExtents": [
        2.3,
        0.55,
        0.15
      ],
      "material": "metal",
      "note": "catwalk rail"
    },
    {
      "kind": "box",
      "center": [
        -3.5,
        3.75,
        2.15
      ],
      "halfExtents": [
        3.5,
        0.55,
        0.15
      ],
      "material": "metal",
      "note": "catwalk rail"
    },
    {
      "kind": "box",
      "center": [
        6.8,
        3.05,
        -5.8
      ],
      "halfExtents": [
        6.8,
        0.15,
        3.8
      ],
      "material": "metal",
      "note": "catwalk deck"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.075,
        2.843
      ],
      "halfExtents": [
        1,
        0.075,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 1"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.15,
        2.617
      ],
      "halfExtents": [
        1,
        0.15,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 2"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.225,
        2.392
      ],
      "halfExtents": [
        1,
        0.225,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 3"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.3,
        2.167
      ],
      "halfExtents": [
        1,
        0.3,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 4"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.375,
        1.943
      ],
      "halfExtents": [
        1,
        0.375,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 5"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.45,
        1.717
      ],
      "halfExtents": [
        1,
        0.45,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 6"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.525,
        1.492
      ],
      "halfExtents": [
        1,
        0.525,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 7"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.6,
        1.267
      ],
      "halfExtents": [
        1,
        0.6,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 8"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.675,
        1.042
      ],
      "halfExtents": [
        1,
        0.675,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 9"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.75,
        0.817
      ],
      "halfExtents": [
        1,
        0.75,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 10"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.825,
        0.592
      ],
      "halfExtents": [
        1,
        0.825,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 11"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.9,
        0.368
      ],
      "halfExtents": [
        1,
        0.9,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 12"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.975,
        0.143
      ],
      "halfExtents": [
        1,
        0.975,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 13"
    },
    {
      "kind": "box",
      "center": [
        8,
        1.05,
        -0.083
      ],
      "halfExtents": [
        1,
        1.05,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 14"
    },
    {
      "kind": "box",
      "center": [
        8,
        1.125,
        -0.308
      ],
      "halfExtents": [
        1,
        1.125,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 15"
    },
    {
      "kind": "box",
      "center": [
        8,
        1.2,
        -0.533
      ],
      "halfExtents": [
        1,
        1.2,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 16"
    },
    {
      "kind": "box",
      "center": [
        8,
        1.275,
        -0.757
      ],
      "halfExtents": [
        1,
        1.275,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 17"
    },
    {
      "kind": "box",
      "center": [
        8,
        1.35,
        -0.982
      ],
      "halfExtents": [
        1,
        1.35,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 18"
    },
    {
      "kind": "box",
      "center": [
        8,
        1.425,
        -1.208
      ],
      "halfExtents": [
        1,
        1.425,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 19"
    },
    {
      "kind": "box",
      "center": [
        8,
        1.5,
        -1.433
      ],
      "halfExtents": [
        1,
        1.5,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 20"
    },
    {
      "kind": "box",
      "center": [
        8,
        1.575,
        -1.657
      ],
      "halfExtents": [
        1,
        1.575,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 21"
    },
    {
      "kind": "box",
      "center": [
        8,
        1.6,
        -1.883
      ],
      "halfExtents": [
        1,
        1.6,
        0.113
      ],
      "material": "metal",
      "note": "catwalk stair step 22"
    },
    {
      "kind": "box",
      "center": [
        11.3,
        3.75,
        -2.15
      ],
      "halfExtents": [
        2.3,
        0.55,
        0.15
      ],
      "material": "metal",
      "note": "catwalk rail"
    },
    {
      "kind": "box",
      "center": [
        3.5,
        3.75,
        -2.15
      ],
      "halfExtents": [
        3.5,
        0.55,
        0.15
      ],
      "material": "metal",
      "note": "catwalk rail"
    },
    {
      "kind": "box",
      "center": [
        -18,
        3.6,
        -9.5
      ],
      "halfExtents": [
        0.2,
        0.06,
        0.5
      ],
      "material": "metal",
      "emissive": "#ffc987",
      "emissiveIntensity": 3,
      "note": "crossing lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -18,
        3.6,
        7.5
      ],
      "halfExtents": [
        0.2,
        0.06,
        0.5
      ],
      "material": "metal",
      "emissive": "#ffc987",
      "emissiveIntensity": 3,
      "note": "crossing lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -18,
        1.6,
        -16
      ],
      "halfExtents": [
        0.6,
        1.6,
        4
      ],
      "material": "concrete",
      "note": "mouth wall"
    },
    {
      "kind": "box",
      "center": [
        -18,
        1.6,
        -1
      ],
      "halfExtents": [
        0.6,
        1.6,
        6
      ],
      "material": "concrete",
      "note": "mouth wall"
    },
    {
      "kind": "box",
      "center": [
        -18,
        1.6,
        15
      ],
      "halfExtents": [
        0.6,
        1.6,
        5
      ],
      "material": "concrete",
      "note": "mouth wall"
    },
    {
      "kind": "box",
      "center": [
        18,
        1.6,
        16
      ],
      "halfExtents": [
        0.6,
        1.6,
        4
      ],
      "material": "concrete",
      "note": "mouth wall"
    },
    {
      "kind": "box",
      "center": [
        18,
        1.6,
        1
      ],
      "halfExtents": [
        0.6,
        1.6,
        6
      ],
      "material": "concrete",
      "note": "mouth wall"
    },
    {
      "kind": "box",
      "center": [
        18,
        1.6,
        -15
      ],
      "halfExtents": [
        0.6,
        1.6,
        5
      ],
      "material": "concrete",
      "note": "mouth wall"
    },
    {
      "kind": "box",
      "center": [
        -10,
        8.2,
        13
      ],
      "halfExtents": [
        0.5,
        0.08,
        0.3
      ],
      "material": "metal",
      "emissive": "#ffe0b0",
      "emissiveIntensity": 3,
      "note": "gantry flood fixture"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.6,
        15
      ],
      "halfExtents": [
        10,
        0.6,
        3
      ],
      "material": "concrete",
      "note": "crane pier"
    },
    {
      "kind": "box",
      "center": [
        -21.692,
        0.075,
        15
      ],
      "halfExtents": [
        0.113,
        0.075,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 1"
    },
    {
      "kind": "box",
      "center": [
        -21.467,
        0.15,
        15
      ],
      "halfExtents": [
        0.113,
        0.15,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 2"
    },
    {
      "kind": "box",
      "center": [
        -21.242,
        0.225,
        15
      ],
      "halfExtents": [
        0.113,
        0.225,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 3"
    },
    {
      "kind": "box",
      "center": [
        -21.017,
        0.3,
        15
      ],
      "halfExtents": [
        0.113,
        0.3,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 4"
    },
    {
      "kind": "box",
      "center": [
        -20.792,
        0.375,
        15
      ],
      "halfExtents": [
        0.113,
        0.375,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 5"
    },
    {
      "kind": "box",
      "center": [
        -20.567,
        0.45,
        15
      ],
      "halfExtents": [
        0.113,
        0.45,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 6"
    },
    {
      "kind": "box",
      "center": [
        -20.342,
        0.525,
        15
      ],
      "halfExtents": [
        0.113,
        0.525,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 7"
    },
    {
      "kind": "box",
      "center": [
        -20.117,
        0.6,
        15
      ],
      "halfExtents": [
        0.113,
        0.6,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 8"
    },
    {
      "kind": "box",
      "center": [
        -17,
        4.6,
        13
      ],
      "halfExtents": [
        0.3,
        3.4,
        0.3
      ],
      "material": "metal",
      "note": "gantry leg"
    },
    {
      "kind": "box",
      "center": [
        -3,
        4.6,
        13
      ],
      "halfExtents": [
        0.3,
        3.4,
        0.3
      ],
      "material": "metal",
      "note": "gantry leg"
    },
    {
      "kind": "box",
      "center": [
        -10,
        8.3,
        13
      ],
      "halfExtents": [
        8,
        0.3,
        0.4
      ],
      "material": "metal",
      "note": "gantry boom"
    },
    {
      "kind": "box",
      "center": [
        -14,
        1.3,
        16
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "rust",
      "note": "container x level 0"
    },
    {
      "kind": "box",
      "center": [
        -6,
        1.3,
        16
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "metal",
      "note": "container x level 0"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.6,
        -15
      ],
      "halfExtents": [
        10,
        0.6,
        3
      ],
      "material": "concrete",
      "note": "crane pier"
    },
    {
      "kind": "box",
      "center": [
        21.692,
        0.075,
        -15
      ],
      "halfExtents": [
        0.113,
        0.075,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 1"
    },
    {
      "kind": "box",
      "center": [
        21.467,
        0.15,
        -15
      ],
      "halfExtents": [
        0.113,
        0.15,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 2"
    },
    {
      "kind": "box",
      "center": [
        21.242,
        0.225,
        -15
      ],
      "halfExtents": [
        0.113,
        0.225,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 3"
    },
    {
      "kind": "box",
      "center": [
        21.017,
        0.3,
        -15
      ],
      "halfExtents": [
        0.113,
        0.3,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 4"
    },
    {
      "kind": "box",
      "center": [
        20.792,
        0.375,
        -15
      ],
      "halfExtents": [
        0.113,
        0.375,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 5"
    },
    {
      "kind": "box",
      "center": [
        20.567,
        0.45,
        -15
      ],
      "halfExtents": [
        0.113,
        0.45,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 6"
    },
    {
      "kind": "box",
      "center": [
        20.342,
        0.525,
        -15
      ],
      "halfExtents": [
        0.113,
        0.525,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 7"
    },
    {
      "kind": "box",
      "center": [
        20.117,
        0.6,
        -15
      ],
      "halfExtents": [
        0.113,
        0.6,
        1.25
      ],
      "material": "concrete",
      "note": "pier stair step 8"
    },
    {
      "kind": "box",
      "center": [
        17,
        4.6,
        -13
      ],
      "halfExtents": [
        0.3,
        3.4,
        0.3
      ],
      "material": "metal",
      "note": "gantry leg"
    },
    {
      "kind": "box",
      "center": [
        3,
        4.6,
        -13
      ],
      "halfExtents": [
        0.3,
        3.4,
        0.3
      ],
      "material": "metal",
      "note": "gantry leg"
    },
    {
      "kind": "box",
      "center": [
        10,
        8.3,
        -13
      ],
      "halfExtents": [
        8,
        0.3,
        0.4
      ],
      "material": "metal",
      "note": "gantry boom"
    },
    {
      "kind": "box",
      "center": [
        14,
        1.3,
        -16
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "rust",
      "note": "container x level 0"
    },
    {
      "kind": "box",
      "center": [
        6,
        1.3,
        -16
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "metal",
      "note": "container x level 0"
    },
    {
      "kind": "box",
      "center": [
        -8,
        1.3,
        20
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "metal",
      "note": "container x level 0"
    },
    {
      "kind": "box",
      "center": [
        4,
        1.3,
        12
      ],
      "halfExtents": [
        1.3,
        1.3,
        3
      ],
      "material": "rust",
      "note": "container z level 0"
    },
    {
      "kind": "box",
      "center": [
        4,
        3.9,
        12
      ],
      "halfExtents": [
        1.3,
        1.3,
        3
      ],
      "material": "metal",
      "note": "container z level 1"
    },
    {
      "kind": "box",
      "center": [
        8,
        1.3,
        -20
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "metal",
      "note": "container x level 0"
    },
    {
      "kind": "box",
      "center": [
        -4,
        1.3,
        -12
      ],
      "halfExtents": [
        1.3,
        1.3,
        3
      ],
      "material": "rust",
      "note": "container z level 0"
    },
    {
      "kind": "box",
      "center": [
        -4,
        3.9,
        -12
      ],
      "halfExtents": [
        1.3,
        1.3,
        3
      ],
      "material": "metal",
      "note": "container z level 1"
    },
    {
      "kind": "box",
      "center": [
        -32,
        4.6,
        26.6
      ],
      "halfExtents": [
        0.35,
        0.07,
        0.2
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "lane lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -16,
        4.6,
        26.6
      ],
      "halfExtents": [
        0.35,
        0.07,
        0.2
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "lane lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        0,
        4.6,
        26.6
      ],
      "halfExtents": [
        0.35,
        0.07,
        0.2
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "lane lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        16,
        4.6,
        26.6
      ],
      "halfExtents": [
        0.35,
        0.07,
        0.2
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "lane lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        32,
        4.6,
        26.6
      ],
      "halfExtents": [
        0.35,
        0.07,
        0.2
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "lane lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -34,
        1.3,
        23.2
      ],
      "halfExtents": [
        3,
        1.3,
        1
      ],
      "material": "metal",
      "note": "lane container"
    },
    {
      "kind": "box",
      "center": [
        -22,
        1.3,
        23.2
      ],
      "halfExtents": [
        3,
        1.3,
        1
      ],
      "material": "metal",
      "note": "lane container"
    },
    {
      "kind": "box",
      "center": [
        -6,
        1.3,
        23.2
      ],
      "halfExtents": [
        3,
        1.3,
        1
      ],
      "material": "metal",
      "note": "lane container"
    },
    {
      "kind": "box",
      "center": [
        12,
        1.3,
        23.2
      ],
      "halfExtents": [
        3,
        1.3,
        1
      ],
      "material": "rust",
      "note": "lane container"
    },
    {
      "kind": "box",
      "center": [
        28,
        1.3,
        23.2
      ],
      "halfExtents": [
        3,
        1.3,
        1
      ],
      "material": "rust",
      "note": "lane container"
    },
    {
      "kind": "box",
      "center": [
        34,
        1.3,
        -23.2
      ],
      "halfExtents": [
        3,
        1.3,
        1
      ],
      "material": "metal",
      "note": "lane container"
    },
    {
      "kind": "box",
      "center": [
        22,
        1.3,
        -23.2
      ],
      "halfExtents": [
        3,
        1.3,
        1
      ],
      "material": "metal",
      "note": "lane container"
    },
    {
      "kind": "box",
      "center": [
        6,
        1.3,
        -23.2
      ],
      "halfExtents": [
        3,
        1.3,
        1
      ],
      "material": "metal",
      "note": "lane container"
    },
    {
      "kind": "box",
      "center": [
        -12,
        1.3,
        -23.2
      ],
      "halfExtents": [
        3,
        1.3,
        1
      ],
      "material": "rust",
      "note": "lane container"
    },
    {
      "kind": "box",
      "center": [
        -28,
        1.3,
        -23.2
      ],
      "halfExtents": [
        3,
        1.3,
        1
      ],
      "material": "rust",
      "note": "lane container"
    },
    {
      "kind": "box",
      "center": [
        -30,
        5.5,
        -7
      ],
      "halfExtents": [
        0.5,
        0.08,
        0.5
      ],
      "material": "metal",
      "emissive": "#ffe2b8",
      "emissiveIntensity": 3,
      "note": "yard lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -30,
        5.5,
        7
      ],
      "halfExtents": [
        0.5,
        0.08,
        0.5
      ],
      "material": "metal",
      "emissive": "#ffe2b8",
      "emissiveIntensity": 3,
      "note": "yard lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -30,
        -0.14,
        0
      ],
      "halfExtents": [
        9.5,
        0.15,
        14
      ],
      "material": "gravel",
      "note": "yard pad"
    },
    {
      "kind": "box",
      "center": [
        -24,
        1.3,
        -10
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "rust",
      "note": "container x level 0"
    },
    {
      "kind": "box",
      "center": [
        -24,
        1.3,
        10
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "metal",
      "note": "container x level 0"
    },
    {
      "kind": "box",
      "center": [
        -22,
        1.3,
        0
      ],
      "halfExtents": [
        1.3,
        1.3,
        3
      ],
      "material": "rust",
      "note": "container z level 0"
    },
    {
      "kind": "box",
      "center": [
        -22,
        3.9,
        0
      ],
      "halfExtents": [
        1.3,
        1.3,
        3
      ],
      "material": "metal",
      "note": "container z level 1"
    },
    {
      "kind": "box",
      "center": [
        -36,
        0.6,
        -12.5
      ],
      "halfExtents": [
        1.2,
        0.6,
        1.2
      ],
      "material": "wood",
      "note": "yard crate block"
    },
    {
      "kind": "box",
      "center": [
        -36,
        0.6,
        12.5
      ],
      "halfExtents": [
        1.2,
        0.6,
        1.2
      ],
      "material": "wood",
      "note": "yard crate block"
    },
    {
      "kind": "box",
      "center": [
        30,
        -0.14,
        0
      ],
      "halfExtents": [
        9.5,
        0.15,
        14
      ],
      "material": "gravel",
      "note": "yard pad"
    },
    {
      "kind": "box",
      "center": [
        24,
        1.3,
        10
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "rust",
      "note": "container x level 0"
    },
    {
      "kind": "box",
      "center": [
        24,
        1.3,
        -10
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "metal",
      "note": "container x level 0"
    },
    {
      "kind": "box",
      "center": [
        22,
        1.3,
        0
      ],
      "halfExtents": [
        1.3,
        1.3,
        3
      ],
      "material": "rust",
      "note": "container z level 0"
    },
    {
      "kind": "box",
      "center": [
        22,
        3.9,
        0
      ],
      "halfExtents": [
        1.3,
        1.3,
        3
      ],
      "material": "metal",
      "note": "container z level 1"
    },
    {
      "kind": "box",
      "center": [
        36,
        0.6,
        12.5
      ],
      "halfExtents": [
        1.2,
        0.6,
        1.2
      ],
      "material": "wood",
      "note": "yard crate block"
    },
    {
      "kind": "box",
      "center": [
        36,
        0.6,
        -12.5
      ],
      "halfExtents": [
        1.2,
        0.6,
        1.2
      ],
      "material": "wood",
      "note": "yard crate block"
    },
    {
      "kind": "box",
      "center": [
        0,
        6.73,
        0
      ],
      "halfExtents": [
        0.04,
        0.27,
        0.04
      ],
      "material": "metal",
      "note": "warehouse centre pendant fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -7,
        6.63,
        -5
      ],
      "halfExtents": [
        0.04,
        0.37,
        0.04
      ],
      "material": "metal",
      "note": "warehouse bay pendant fixture mount"
    },
    {
      "kind": "box",
      "center": [
        4,
        3.4,
        -10.325
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.325
      ],
      "material": "metal",
      "note": "warehouse door lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -18,
        1.77,
        -9.5
      ],
      "halfExtents": [
        0.04,
        1.77,
        0.04
      ],
      "material": "metal",
      "note": "crossing lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -18,
        1.77,
        7.5
      ],
      "halfExtents": [
        0.04,
        1.77,
        0.04
      ],
      "material": "metal",
      "note": "crossing lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -32,
        4.6,
        27.15
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.35
      ],
      "material": "metal",
      "note": "lane lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -16,
        4.6,
        27.15
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.35
      ],
      "material": "metal",
      "note": "lane lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        0,
        4.6,
        27.15
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.35
      ],
      "material": "metal",
      "note": "lane lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        16,
        4.6,
        27.15
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.35
      ],
      "material": "metal",
      "note": "lane lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        32,
        4.6,
        27.15
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.35
      ],
      "material": "metal",
      "note": "lane lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -30,
        2.715,
        -7
      ],
      "halfExtents": [
        0.04,
        2.705,
        0.04
      ],
      "material": "metal",
      "note": "yard lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -30,
        2.715,
        7
      ],
      "halfExtents": [
        0.04,
        2.705,
        0.04
      ],
      "material": "metal",
      "note": "yard lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -22,
        0.595,
        12
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        22,
        0.595,
        -12
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        -28,
        0.595,
        25.5
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        28,
        0.595,
        -25.5
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        -28,
        0.595,
        -6
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        -28,
        0.595,
        6
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        28,
        0.595,
        6
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        28,
        0.595,
        -6
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    }
  ],
  "spawns": [
    {
      "position": [
        -35,
        0.05,
        -6
      ],
      "yaw": 4.543,
      "team": 0
    },
    {
      "position": [
        35,
        0.05,
        6
      ],
      "yaw": 1.401,
      "team": 1
    },
    {
      "position": [
        -35,
        0.05,
        -3
      ],
      "yaw": 4.627,
      "team": 0
    },
    {
      "position": [
        35,
        0.05,
        3
      ],
      "yaw": 1.485,
      "team": 1
    },
    {
      "position": [
        -35,
        0.05,
        3
      ],
      "yaw": 4.798,
      "team": 0
    },
    {
      "position": [
        35,
        0.05,
        -3
      ],
      "yaw": 1.656,
      "team": 1
    },
    {
      "position": [
        -35,
        0.05,
        6
      ],
      "yaw": 4.882,
      "team": 0
    },
    {
      "position": [
        35,
        0.05,
        -6
      ],
      "yaw": 1.74,
      "team": 1
    },
    {
      "position": [
        -33,
        0.05,
        -6
      ],
      "yaw": 4.533,
      "team": 0
    },
    {
      "position": [
        33,
        0.05,
        6
      ],
      "yaw": 1.391,
      "team": 1
    },
    {
      "position": [
        -33,
        0.05,
        -3
      ],
      "yaw": 4.622,
      "team": 0
    },
    {
      "position": [
        33,
        0.05,
        3
      ],
      "yaw": 1.48,
      "team": 1
    },
    {
      "position": [
        -33,
        0.05,
        3
      ],
      "yaw": 4.803,
      "team": 0
    },
    {
      "position": [
        33,
        0.05,
        -3
      ],
      "yaw": 1.661,
      "team": 1
    },
    {
      "position": [
        -33,
        0.05,
        6
      ],
      "yaw": 4.892,
      "team": 0
    },
    {
      "position": [
        33,
        0.05,
        -6
      ],
      "yaw": 1.75,
      "team": 1
    }
  ],
  "props": [
    {
      "model": "/game/models/hangar/barrels.glb",
      "position": [
        -12,
        0,
        1
      ]
    },
    {
      "model": "/game/models/urban/pallet-broken.glb",
      "position": [
        -2,
        0,
        4
      ]
    },
    {
      "model": "/game/models/hangar/barrels.glb",
      "position": [
        12,
        0,
        -1
      ]
    },
    {
      "model": "/game/models/urban/pallet-broken.glb",
      "position": [
        2,
        0,
        -4
      ]
    },
    {
      "model": "/game/models/hangar/barrel.glb",
      "position": [
        -11.5,
        3.2,
        8
      ]
    },
    {
      "model": "/game/models/hangar/barrel.glb",
      "position": [
        11.5,
        3.2,
        -8
      ]
    },
    {
      "model": "/game/models/hangar/machine_generator.glb",
      "position": [
        -10,
        1.2,
        14
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        -22,
        0,
        12
      ]
    },
    {
      "model": "/game/models/hangar/machine_generator.glb",
      "position": [
        10,
        1.2,
        -14
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        22,
        0,
        -12
      ]
    },
    {
      "model": "/game/models/urban/pallet-broken.glb",
      "position": [
        10,
        0,
        18
      ]
    },
    {
      "model": "/game/models/urban/pallet-broken.glb",
      "position": [
        -10,
        0,
        -18
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        -28,
        0,
        25.5
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        28,
        0,
        -25.5
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        -28,
        0,
        -6
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        -28,
        0,
        6
      ]
    },
    {
      "model": "/game/models/hangar/barrels.glb",
      "position": [
        -38,
        0,
        0
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        28,
        0,
        6
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        28,
        0,
        -6
      ]
    },
    {
      "model": "/game/models/hangar/barrels.glb",
      "position": [
        38,
        0,
        0
      ]
    }
  ],
  "lights": [
    {
      "kind": "point",
      "position": [
        0,
        6.4,
        0
      ],
      "color": "#ffd9a8",
      "intensity": 55,
      "distance": 18,
      "note": "warehouse centre pendant"
    },
    {
      "kind": "point",
      "position": [
        -7,
        6.2,
        -5
      ],
      "color": "#ffd9a8",
      "intensity": 40,
      "distance": 14,
      "note": "warehouse bay pendant"
    },
    {
      "kind": "point",
      "position": [
        7,
        6.2,
        5
      ],
      "color": "#ffd9a8",
      "intensity": 40,
      "distance": 14,
      "note": "warehouse bay pendant"
    },
    {
      "kind": "point",
      "position": [
        -4,
        3.4,
        -10.8
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 9,
      "note": "warehouse door lamp"
    },
    {
      "kind": "point",
      "position": [
        4,
        3.4,
        -10.8
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 9,
      "note": "warehouse door lamp"
    },
    {
      "kind": "point",
      "position": [
        4,
        3.4,
        10.8
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 9,
      "note": "warehouse door lamp"
    },
    {
      "kind": "point",
      "position": [
        -4,
        3.4,
        10.8
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 9,
      "note": "warehouse door lamp"
    },
    {
      "kind": "point",
      "position": [
        -18,
        3.6,
        -9.5
      ],
      "color": "#ffc987",
      "intensity": 34,
      "distance": 10,
      "note": "crossing lamp"
    },
    {
      "kind": "point",
      "position": [
        -18,
        3.6,
        7.5
      ],
      "color": "#ffc987",
      "intensity": 34,
      "distance": 10,
      "note": "crossing lamp"
    },
    {
      "kind": "point",
      "position": [
        18,
        3.6,
        9.5
      ],
      "color": "#ffc987",
      "intensity": 34,
      "distance": 10,
      "note": "crossing lamp"
    },
    {
      "kind": "point",
      "position": [
        18,
        3.6,
        -7.5
      ],
      "color": "#ffc987",
      "intensity": 34,
      "distance": 10,
      "note": "crossing lamp"
    },
    {
      "kind": "point",
      "position": [
        -10,
        8.2,
        13
      ],
      "color": "#ffe0b0",
      "intensity": 60,
      "distance": 20,
      "note": "gantry flood"
    },
    {
      "kind": "point",
      "position": [
        10,
        8.2,
        -13
      ],
      "color": "#ffe0b0",
      "intensity": 60,
      "distance": 20,
      "note": "gantry flood"
    },
    {
      "kind": "point",
      "position": [
        -32,
        4.6,
        26.6
      ],
      "color": "#ffcf90",
      "intensity": 36,
      "distance": 14,
      "note": "lane lamp"
    },
    {
      "kind": "point",
      "position": [
        -16,
        4.6,
        26.6
      ],
      "color": "#ffcf90",
      "intensity": 36,
      "distance": 14,
      "note": "lane lamp"
    },
    {
      "kind": "point",
      "position": [
        0,
        4.6,
        26.6
      ],
      "color": "#ffcf90",
      "intensity": 36,
      "distance": 14,
      "note": "lane lamp"
    },
    {
      "kind": "point",
      "position": [
        16,
        4.6,
        26.6
      ],
      "color": "#ffcf90",
      "intensity": 36,
      "distance": 14,
      "note": "lane lamp"
    },
    {
      "kind": "point",
      "position": [
        32,
        4.6,
        26.6
      ],
      "color": "#ffcf90",
      "intensity": 36,
      "distance": 14,
      "note": "lane lamp"
    },
    {
      "kind": "point",
      "position": [
        32,
        4.6,
        -26.6
      ],
      "color": "#ffcf90",
      "intensity": 36,
      "distance": 14,
      "note": "lane lamp"
    },
    {
      "kind": "point",
      "position": [
        16,
        4.6,
        -26.6
      ],
      "color": "#ffcf90",
      "intensity": 36,
      "distance": 14,
      "note": "lane lamp"
    },
    {
      "kind": "point",
      "position": [
        0,
        4.6,
        -26.6
      ],
      "color": "#ffcf90",
      "intensity": 36,
      "distance": 14,
      "note": "lane lamp"
    },
    {
      "kind": "point",
      "position": [
        -16,
        4.6,
        -26.6
      ],
      "color": "#ffcf90",
      "intensity": 36,
      "distance": 14,
      "note": "lane lamp"
    },
    {
      "kind": "point",
      "position": [
        -32,
        4.6,
        -26.6
      ],
      "color": "#ffcf90",
      "intensity": 36,
      "distance": 14,
      "note": "lane lamp"
    },
    {
      "kind": "point",
      "position": [
        -30,
        5.5,
        -7
      ],
      "color": "#ffe2b8",
      "intensity": 70,
      "distance": 20,
      "note": "yard lamp"
    },
    {
      "kind": "point",
      "position": [
        -30,
        5.5,
        7
      ],
      "color": "#ffe2b8",
      "intensity": 70,
      "distance": 20,
      "note": "yard lamp"
    },
    {
      "kind": "spot",
      "position": [
        -38,
        9,
        0
      ],
      "color": "#fff1dc",
      "intensity": 260,
      "distance": 30,
      "target": [
        -20,
        0,
        0
      ],
      "angle": 0.65,
      "penumbra": 0.4,
      "castShadow": true,
      "note": "yard flood"
    },
    {
      "kind": "point",
      "position": [
        30,
        5.5,
        7
      ],
      "color": "#ffe2b8",
      "intensity": 70,
      "distance": 20,
      "note": "yard lamp"
    },
    {
      "kind": "point",
      "position": [
        30,
        5.5,
        -7
      ],
      "color": "#ffe2b8",
      "intensity": 70,
      "distance": 20,
      "note": "yard lamp"
    },
    {
      "kind": "spot",
      "position": [
        38,
        9,
        0
      ],
      "color": "#fff1dc",
      "intensity": 260,
      "distance": 30,
      "target": [
        20,
        0,
        0
      ],
      "angle": 0.65,
      "penumbra": 0.4,
      "castShadow": true,
      "note": "yard flood"
    }
  ],
  "sites": [
    {
      "id": "A",
      "center": [
        -10,
        1,
        20
      ],
      "halfExtents": [
        4,
        2,
        4
      ]
    },
    {
      "id": "B",
      "center": [
        10,
        1,
        -20
      ],
      "halfExtents": [
        4,
        2,
        4
      ]
    }
  ]
}
